import React, { Component } from "react";
import DebitsTable from "./debitsTable";
import { getDebits } from "../services/debitService";
import Spinner from "./common/spinner";

class Debits extends Component {
  state = {
    debits: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const result = await getDebits();
    this.setState({ loading: false });
    const { data: debits } = result.data;
    this.setState({ debits });
  }

  getPagedData = () => {
    const { debits } = this.state;

    return { data: debits };
  };

  render() {
    const { data: debits } = this.getPagedData();
    const { loading } = this.state;
    if (loading) return <Spinner message="loading page data..." />;
    return (
      <React.Fragment>
        <DebitsTable debits={debits} message="Fund Withdrawals" />
      </React.Fragment>
    );
  }
}

export default Debits;
